import React from "react";
import AppButton from "../layout/AppButton";

const EditReportModal = ({ open, reportData, onClose, onChange, onSubmit, updating }) => {
    if (!open || !reportData) return null;

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content rr-manageCard">
                        <div className="modal-header border-0 pb-1">
                            <h5 className="modal-title">Edit Report</h5>
                            <AppButton
                                variant="outline"
                                onClick={onClose}
                                style={{ padding: "2px 10px", lineHeight: 1, minWidth: "unset" }}
                                title="Close"
                            >
                                ×
                            </AppButton>
                        </div>

                        <form onSubmit={onSubmit}>
                            <div className="modal-body">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">Report Name</label>
                                        <input
                                            type="text"
                                            name="reportName"
                                            className="form-control rr-input"
                                            value={reportData.reportName}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">Report ID</label>
                                        <input
                                            type="text"
                                            name="reportId"
                                            className="form-control rr-input"
                                            value={reportData.reportId}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">Group ID</label>
                                        <input
                                            type="text"
                                            name="groupId"
                                            className="form-control rr-input"
                                            value={reportData.groupId}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">Dataset ID</label>
                                        <input
                                            type="text"
                                            name="datasetId"
                                            className="form-control rr-input"
                                            value={reportData.datasetId}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">Report URL</label>
                                        <input
                                            type="text"
                                            name="reportUrl"
                                            className="form-control rr-input"
                                            value={reportData.reportUrl}
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label rr-label">RLS Enabled</label>
                                        <div className="rr-toggle" role="radiogroup" aria-label="RLS Enabled">
                                            <label className={`rr-toggleOption ${reportData.rlsEnabled === "true" ? "active" : ""}`}>
                                                <input
                                                    type="radio"
                                                    name="rlsEnabled"
                                                    value="true"
                                                    checked={reportData.rlsEnabled === "true"}
                                                    onChange={onChange}
                                                />
                                                True
                                            </label>
                                            <label className={`rr-toggleOption ${reportData.rlsEnabled === "false" ? "active" : ""}`}>
                                                <input
                                                    type="radio"
                                                    name="rlsEnabled"
                                                    value="false"
                                                    checked={reportData.rlsEnabled === "false"}
                                                    onChange={onChange}
                                                />
                                                False
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label rr-label">Report Description</label>
                                        <textarea
                                            name="reportDescription"
                                            className="form-control rr-input rr-textarea"
                                            rows="4"
                                            value={reportData.reportDescription}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer border-0 justify-content-end d-flex gap-2">
                                <AppButton
                                    type="button"
                                    variant="secondary"
                                    onClick={onClose}
                                    disabled={updating}
                                >
                                    Cancel
                                </AppButton>
                                <AppButton
                                    type="submit"
                                    variant="fill"
                                    disabled={updating}
                                >
                                    {updating ? "Updating..." : "Update"}
                                </AppButton>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
};

export default EditReportModal;
